import { takeLatest, call, put, all} from 'redux-saga/effects';
import { LOGIN_START, LOGIN_SUCCESS, LOGIN_ERROR, LOGOUT, LOGOUT_START } from './../types';
import { signin, signout } from '../../services/authServices';
import { toast } from 'react-toastify';

export function* postLogin({ payload }) {
  try {
    const response = yield call(signin, payload);
    if(response.status === 200 )
      {
        yield put({ type: LOGIN_SUCCESS, payload: response.data });
        toast.success('Bienvenido')
      }else{
        yield put({ type: LOGIN_ERROR, payload: response?.data?.message });
      }
  } catch (error) {
    yield put({ type: LOGIN_ERROR, payload: error?.response?.data});
  }
}

export function* postLogout() {
  try {
    yield call(signout);
  } catch (error) {
    // el logout local debe ocurrir igual aunque falle la invalidación en el backend
  } finally {
    yield put({ type: LOGOUT });
  }
}

export default function* login() {
  yield all([
    takeLatest(LOGIN_START, postLogin),
    takeLatest(LOGOUT_START, postLogout),
  ]);
}
